import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=0e302d5e&scoped=true"
import script from "./effect.vue?vue&type=script&lang=ts"
export * from "./effect.vue?vue&type=script&lang=ts"
import style0 from "./effect.vue?vue&type=style&index=0&id=0e302d5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e302d5e",
  null
  
)

export default component.exports